import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { memo } from 'react'

export interface Props {
  onClick: () => void
  variant?: Variant
}

export const ModalClose = memo(function ModalClose({
  onClick,
  variant = 'left',
}: Props) {
  return <Container onClick={onClick} variant={variant} />
})

const Container = styled.div<ContainerProps>`
  width: 2.5rem;
  height: 2.5rem;
  background: ${({ theme }) => theme.colors.variants.neutralLight3};
  cursor: pointer;
  position: absolute;
  top: 2.75rem;
  left: 2.125rem;
  z-index: 2;
  transition: 0.3s ease-out;
  &:hover {
    background: ${({ theme }) => theme.colors.variants.neutralLight1};
    &:before,
    &:after {
      transform: none;
    }
  }
  &:before,
  &:after {
    content: '';
    width: 20px;
    height: 2px;
    background: ${({ theme }) => theme.colors.variants.neutralDark3};
    position: absolute;
    top: 1.125rem;
    left: 0.5625rem;
    transition: 0.3s ease-out;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }

  ${({ theme, variant }) => {
    switch (variant) {
      case 'right':
        return css`
          background: ${theme.colors.variants.neutralLight4};
          right: 2.125rem;
          left: auto;
        `
    }
  }}

  @media (max-width: 767px) {
    top: 0;
    left: 0;
  }
`

interface ContainerProps {
  variant: Variant
}

export type Variant = 'left' | 'right'
